(function () {
  'use strict';

  var modal = document.getElementById('ras-quick-view-modal');
  if (!modal) return;
  
  var modalBody = document.getElementById('ras-quick-view-body');
  var closeBtns = modal.querySelectorAll('[data-close-quick-view]');

  function openQuickView(handle) {
    // Show modal and loading state
    modal.classList.add('is-open');
    document.body.classList.add('quick-view-open');
    modal.setAttribute('aria-hidden', 'false');
    
    modalBody.innerHTML = `
      <div class="ras-quick-view-loader" style="display: flex; gap: 32px; padding: 24px; min-height: 400px;">
        <div class="ras-skeleton-box" style="flex: 1; min-width: 300px; height: 300px; border-radius: 12px;"></div>
        <div style="flex: 1; display: flex; flex-direction: column; gap: 16px; padding-top: 12px;">
          <div class="ras-skeleton-box" style="width: 30%; height: 16px; border-radius: 4px;"></div>
          <div class="ras-skeleton-box" style="width: 80%; height: 32px; border-radius: 6px;"></div>
          <div class="ras-skeleton-box" style="width: 25%; height: 24px; border-radius: 4px; margin-bottom: 16px;"></div>
          <div class="ras-skeleton-box" style="width: 100%; height: 14px; border-radius: 4px;"></div>
          <div class="ras-skeleton-box" style="width: 90%; height: 14px; border-radius: 4px;"></div>
          <div class="ras-skeleton-box" style="width: 60%; height: 14px; border-radius: 4px;"></div>
        </div>
      </div>
    `;

    // Fetch product via Section Rendering API
    fetch('/products/' + handle + '?section_id=quick-view-modal-content')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.text();
      })
      .then(function (html) {
        // Extract section content
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (section) {
          modalBody.innerHTML = section.innerHTML;
        } else {
          modalBody.innerHTML = html; // Fallback
        }
        initQuickViewContent();
      })
      .catch(function (error) {
        console.error('Quick View Error:', error);
        modalBody.innerHTML = '<div style="padding: 60px; text-align: center;">Could not load product details.</div>';
      });
  }

  function initQuickViewContent() {
    var desc = modalBody.querySelector('.ras-quick-view-desc');
    if (desc) {
      var btn = desc.parentElement ? desc.parentElement.querySelector('.ras-quick-view-expand-btn') : null;
      var fade = desc.querySelector('.ras-quick-view-desc-fade');
      if (desc.scrollHeight <= 145) {
        if (btn) btn.style.display = 'none';
        if (fade) fade.style.display = 'none';
        desc.style.maxHeight = 'none';
        desc.style.overflow = 'visible';
      }
    }
    updateQuickViewPrice();
    if (window.RAS && typeof window.RAS.syncSoldOutElements === 'function') {
      window.RAS.syncSoldOutElements(modalBody);
    }
  }

  function updateQuickViewPrice() {
    var form = modalBody.querySelector('form[data-product-form]');
    if (!form) return;
    var input = form.querySelector('input[name="quantity"]');
    var priceEl = form.querySelector('.ras-quick-view-total-price');
    var unitPrice = parseInt(form.getAttribute('data-unit-price'), 10);
    if (!input || !priceEl || isNaN(unitPrice)) return;

    var qty = Math.max(1, parseInt(input.value, 10) || 1);
    var totalCents = unitPrice * qty;
    if (window.RAS && typeof window.RAS.money === 'function') {
      priceEl.textContent = window.RAS.money(totalCents);
    }
  }

  // Handle quantity changes in Quick View modal
  modalBody.addEventListener('input', function(event) {
    if (event.target && event.target.name === 'quantity') {
      updateQuickViewPrice();
    }
  });

  modalBody.addEventListener('click', function(event) {
    var btn = event.target.closest('[data-qty-step]');
    if (btn) {
      setTimeout(updateQuickViewPrice, 10);
    }
  });

  function closeQuickView() {
    modal.classList.remove('is-open');
    document.body.classList.remove('quick-view-open');
    modal.setAttribute('aria-hidden', 'true');
    // Clear content after animation
    setTimeout(function() {
      modalBody.innerHTML = '';
    }, 300);
  }

  // Listen for clicks on quick view triggers
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      event.preventDefault();
      var handle = trigger.getAttribute('data-quick-view-trigger');
      if (handle) {
        openQuickView(handle);
      }
    }
  });

  // Listen for close clicks
  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      closeQuickView();
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeQuickView();
    }
  });

})();
